<script setup lang="ts">
definePageMeta({ layout: "search" });

const route = useRoute();

const firstSlug = computed(() => route.params.category?.toString() || "");
const secondSlug = computed(() => route.params.service?.toString() || "");
const thirdSlug = computed(() => route.params.region?.toString() || "");
</script>

<template>
  <WorkersSearchPage
    :first-slug="firstSlug"
    :second-slug="secondSlug"
    :third-slug="thirdSlug"
  />
</template>
